<template>
  <div class="animated fadeIn">
    <b-row align-h="start">
      <b-col md="12">
        <b-row v-if="!freezing">
          <b-col md="10">
            <b-form-group
              name="fileSet"
              :label="title"
              :invalid-feedback="''"
              :valid-feedback="''"
            >
              <b-form-file
                ref="fileAny"
                v-model="anyFile"
                no-drop
                name="any"
                multiple
                :disabled="freezing"
                :placeholder="placeholder"
                @input="inputFile()"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="2"
            class="text-left"
          >
            <b-form-group
              label="리셋"
              :invalid-feedback="''"
              :valid-feedback="''"
            >
              <b-button
                size="md"
                variant="warning"
                @click="clearFiles(true)"
              >
                Reset
              </b-button>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="freezing">
          <b-col
            md="12"
            class="text-left"
          >
            <hr>
            <h6>제출한 작품 리스트:</h6>
          </b-col>
        </b-row>
        <b-row
          v-for="(f, idx) in anyFileAll"
          :key="idx"
        >
          <b-col
            md="11"
            class="text-left"
          >
            <a :href="serverUri + '/cdn/data?id=' + f.id + '&email=' + email">
              {{ f.name }}
            </a>
          </b-col>
          <b-col
            v-if="!freezing"
            md="1"
            class="text-right"
          >
            <b-button
              :disabled="freezing"
              size="sm"
              variant="danger"
              @click="delFile(idx)"
            >
              X
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import api from '../../api'

export default {
  name: 'ApplyFile',
  props: {
    email: {
      type: String,
      required: true
    },
    applyId: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: true
    },
    readOnly: {
      type: Boolean,
      required: true
    }
  },
  data: function () {
    return {
      serverUri: api.serverURI,
      anyFile: [],
      anyFileAll: []
    }
  },
  computed: {
    freezing () {
      return (this.readOnly)
    }
  },
  mounted () {
    this.getApplyFiles()
  },
  methods: {
    setFreezing (val) {
      this.readOnly = val
    },
    getApplyFiles () {
      /* file 처리 성공하고 돌아온 file명들을 문서에 넣는다. */
      api.request('get', '/apply/check?applyId=' + this.applyId + '&info=1&ic=works')
        .then(response => {
          var data = response.data
          if (data.check !== 0) {
            this.parseApply(data)
          }
        })
        .catch(error => {
          this.alertFail(error.response.data.error)
        })
    },
    parseApply (data) {
      this.anyFileAll = data[this.name]
      this.updateFileAll()
    },
    clearFiles (tellToParent) {
      if (this.$refs.fileAny) {
        this.$refs.fileAny.reset()
        this.anyFile = []
        this.anyFileAll = []
        this.updateFileAll()
      }
    },
    delFile (target) {
      this.anyFileAll.splice(target, 1)
      this.updateFileAll()
      if (this.anyFileAll.length === 0) {
        this.clearFiles(true)
      }
    },
    /* 변경되자마자 */
    inputFile () {
      this.anyFile.forEach(f => {
        var dup = false
        this.anyFileAll.forEach(fa => {
          if (fa.name === f.name) {
            dup = true
          }
        })
        if (!dup) {
          var formData = new FormData()
          formData.append('email', this.email)
          formData.append('term', api.currentTerm())
          formData.append(this.name, f, f.name)
          this.fileSave(formData, f.name)
        }
      })
    },
    fileSave (formData, name) {
      api.fileUpload(formData)
        .then(x => {
          var uploadedFiles = [].concat(x)
          this.anyFileAll.push({ 'name': name, 'id': uploadedFiles[0].id })
          this.updateFileAll()
        })
        .catch(err => {
          alert('파일 등록 실패')
          alert(err.response)
        })
    },
    updateFileAll () {
      this.$emit('updateFileAll', this.anyFileAll)
    }
  }
}
</script>

<style>
</style>
